import React from 'react';
import { Formik } from 'formik';
import { object, string } from 'yup';
import BriefTemplateForm from './brief_template_form';
import BriefTemplateWrapper from './brief_template_wrapper';
import { post } from '../../../utils/shared/api';
import { handleSubmitError } from '../../utils/errors';
import GrapeFormat, { formatRawAsOptions } from '../../utils/formatters/formik-grape-formatter';

export default function NewBriefTemplate(props) {
  const { appData } = props;
  const { brandProfileId, accountId } = JSON.parse(appData);

  return (
    <BriefTemplateWrapper createForm>
      <Formik
        initialValues={{
          brandProfileId,
          briefTemplateId: null,
          name: '',
          description: '',
          campaigns: [],
          pillar: null,
          audience: null,
          storyFormat: '',
          fieldTemplates: [],
          tags: []
        }}
        validationSchema={object().shape({
          name: string().required('Name is required'),
          storyFormat: string().required('Story format is required')
        })}
        onSubmit={(values, actions) => {
          post(
            '/api/v1/brief_templates/',
            JSON.stringify(
              GrapeFormat({
                ...values,
                fieldTemplates: formatRawAsOptions(values.fieldTemplates)
              })
            )
          )
            .then(() => window.location.replace('./'))
            .catch(errorResponse => {
              handleSubmitError(
                errorResponse,
                actions,
                'There was an error saving your brief template.'
              );
            });
        }}
        render={innerProps => <BriefTemplateForm {...innerProps} accountId={accountId} />}
      />
    </BriefTemplateWrapper>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/app/components/brief_templates/new_brief_template.jsx